import * as Auth from './Auth';
import * as Coupons from './Coupons';
import * as DashboardStats from "./Dashboard"
import * as Discounts from './Discounts';
import * as Orders from './Orders';
import * as Processing from "./Processing"
import * as Receipt from './Receipt';
import * as Services from './Services';

export {
    Auth,
    Coupons,
    DashboardStats,
    Discounts,
    Orders,
    Processing,
    Receipt,
    Services,
}


// WEBPACK FOOTER //
// ./src/baseparking-api/index.js